import {
  getDriverListService,
  getViolationList,
  getCarListService,
  getVehicleDetails,
  getPolicyInsuredInfo,
} from "../services/policy.service";
export const getAccordionData = (department, allPermissions) => {
  let filterArray = [];
  department.map((dept) => {
    let tempArray = [];
    allPermissions.map((permission) => {
      if (permission.department === dept) {
        permission.isSelected = false;
        tempArray.push(permission);
      }
    });
    filterArray.push({
      department: dept,
      permissionList: tempArray,
      expand: false,
      selectAll: false,
      partialSelected: false,
    });
  });
  return filterArray;
};

export const accordionToPost = (postData) => {
  let rightsDtoList = [];
  postData.forEach((selectedDepartment) => {
    if (selectedDepartment.selectAll || selectedDepartment.partialSelected) {
      selectedDepartment.permissionList.forEach((selectedPermission) => {
        if (selectedPermission.isSelected) {
          rightsDtoList.push({
            flag: true,
            rightsId: selectedPermission.id,
          });
        }
      });
    }
  });
  return rightsDtoList;
};

export const getTwoDecimal = (value) => {
  if (value) {
    let number = value.toFixed(2);
    return number;
  } else {
    return 0.0;
  }
};
export const updateAccordionData = (
  department,
  allPermissions,
  hasPermission,
) => {
  let filterArray = [];
  department.map((dept) => {
    let tempArray = [];
    let count = 0;
    if (hasPermission) {
      hasPermission.map((permission) => {
        if (permission.department === dept) {
          if (permission.hasAccess) {
            permission.isSelected = true;
            count = count + 1;
          } else {
            permission.isSelected = false;
          }
          tempArray.push(permission);
        }
      });
    } else {
      return true;
    }

    filterArray.push({
      department: dept,
      permissionList: tempArray,
      expand: false,
      selectAll: count === tempArray.length ? true : false,
      partialSelected: count > 0 ? true : false,
    });
  });
  return filterArray;
};

export const getURLParamters = () => {
  var url = new URL(window.location.href);
  let pathParamter = url.href.split("/")[6];
  return pathParamter;
};

export const getSearchValue = (value) => {
  let val = value;
  if (val) {
    val = val.trim(" ");
    return val.replace(/%20/g, " ");
  }
  return val;
};

export const getIntials = (value) => {
  if (value) {
    let intials;
    let string = value.split(".");
    intials = string[0].charAt(0) + string[1].charAt(0);
    return intials;
  } else {
    return null;
  }
};

export async function saveAuth(data) {
  localStorage.setItem("AUTH_TOKEN", data.token);
  localStorage.setItem("FIRSTNAME", data.firstName);
  localStorage.setItem("LASTNAME", data.lastName);
  localStorage.setItem("EMAIL", data.emailAddress);
  localStorage.setItem("userId", data.id);
  localStorage.setItem("URL", "claim/csr");
  localStorage.setItem("searchElement", "claimNo");
  localStorage.setItem("userId", data.userId);
  localStorage.setItem("isSuperAdmin", data.isSuperAdmin);
  return data.token;
}

export async function savePermissions  (permissions){
  let permissionList = [];
  let hasPermission = [];
  permissions.forEach((permission) => {
    if (permission.hasAccess) {
      permissionList.push(permission);
      hasPermission.push(permission.shortDesc);
    }
  });
  localStorage.setItem("hasPermission", JSON.stringify(hasPermission));
  localStorage.setItem("permission", JSON.stringify(permissionList));
};

export const getFilterDate = (monthlyData) => {
  let filterData = [];
  monthlyData.forEach((element) => {
    if (!filterData.includes(element.startTime)) {
      filterData.push(new Date(element.startTime));
    }
  });
  return filterData;
};

export const saveOfflineData = (data, url, policyNo) => {
  switch (url) {
    case "get/policy/driver/details?isEndorseMode=false":
    case "get/policy/driver/details?isEndorseMode=true":
      let localDriverList = JSON.parse(localStorage.getItem(`${policyNo}`));
      if (localDriverList) {
        // data = data.concat(localDriverList);
        data = localDriverList;
      } else {
        data.map((driver) => {
          driver.isModified = false;
          driver.policyDriverViolations = driver.policyDriverViolations
            ? driver.policyDriverViolations
            : [];
          driver.dob = driver.dob ? driver.dob : null;
          driver.creditScore = 0;
          driver.dateLicensed = driver.dateLicensed
            ? driver.dateLicensed
            : null;
          driver.inceptionDate = driver.inceptionDate
            ? driver.inceptionDate
            : null;
          return driver;
        });
        localStorage.setItem(`${policyNo}`, JSON.stringify(data));
      }
      break;
    case "get/policy/car/details?isEndorseMode=false":
    case "get/policy/car/details?isEndorseMode=true":
      let localCarList = JSON.parse(localStorage.getItem(`${policyNo}-Cars`));
      if (localCarList) {
        data = localCarList;
      } else {
        data.map((car) => {
          car.isModified = false;
          // car.businessUse = false;
          car.dob = car.dob ? car.dob : null;
          car.inceptionDate = car.inceptionDate ? car.inceptionDate : null;
          car.effDate = car.effDate ? car.effDate : null;
          car.policyCarLienHolders = car.policyCarLienHolders
            ? car.policyCarLienHolders
            : [];
          return car;
        });
        localStorage.setItem(`${policyNo}-Cars`, JSON.stringify(data));
      }
      break;
    case "get/policy/rating/details?isEndorseMode=false":
    case "get/policy/rating/details?isEndorseMode=true":
      let ratingList = JSON.parse(
        localStorage.getItem(`footerSummary-${policyNo}`),
      );
      if (ratingList) {
        data = ratingList.ratingCarList;
      } else {
        localStorage.setItem(
          `footerSummary-${policyNo}`,
          JSON.stringify({ ratingList: data }),
        );
      }
      break;
    default:
      break;
  }
  return data;
};

export const getEndorsePolicyJSON = (policyNo) => {
  let premium = JSON.parse(localStorage.getItem(`premiumForm-${policyNo}`));
  premium.workLoss = premium.workLoss ? 1 : 0;
  let policy = JSON.parse(localStorage.getItem(`policy${policyNo}`));
  let summary = policy.policyInfo;
  summary.ins1First = summary.ins1First ? summary.ins1First.trim("") : "";
  summary.ins1Last = summary.ins1Last ? summary.ins1Last.trim("") : "";
  let producerinfo = policy.agentResp;
  let policySummary = Object.assign({}, summary, producerinfo, premium);
  let amendDate = localStorage.getItem(`amendDate-${policyNo}`);
  let modifieldCarList = JSON.parse(localStorage.getItem(`${policyNo}-Cars`));
  let modifieldDriverList = JSON.parse(localStorage.getItem(`${policyNo}`));
  let apiData = JSON.parse(localStorage.getItem(`Policy-Info-${policyNo}`));
  let driverList = modifieldDriverList
    ? modifieldDriverList
    : apiData.policyDrivers;
  let carList = modifieldCarList ? modifieldCarList : apiData.policyCars;
  driverList.map((driver) => {
    driver.dob = driver.dob ? driver.dob : null;
    driver.dateLicensed = driver.dateLicensed ? driver.dateLicensed : null;
    driver.inceptionDate = driver.inceptionDate ? driver.inceptionDate : null;
    driver.policyDriverViolations = driver.policyDriverViolations
      ? driver.policyDriverViolations
      : [];
    return driver;
  });
  carList.map((car) => {
    car.abs = car.abs === false || car.abs === 0 ? 0 : 1;
    car.dob = car.dob ? car.dob : null;
    car.inceptionDate = car.inceptionDate ? car.inceptionDate : null;
    car.effDate = car.effDate ? car.effDate : null;
    car.policyCarLienHolders = car.policyCarLienHolders
      ? car.policyCarLienHolders
      : [];
    return car;
  });
  let agentEmailAddress = localStorage.getItem(`agentEmailAddress-${policyNo}`);
  let resendPremimumEmail = localStorage.getItem(`confirmation-${policyNo}`);
  let body = {
    policy: policySummary,
    policyCars: carList,
    policyDrivers: driverList,
    amendDate: amendDate,
    agentEmailAddress: agentEmailAddress ? agentEmailAddress : null,
    resendPremimumEmail: resendPremimumEmail ? true : false,
    overrideAsSuperAdmin:
      localStorage.getItem(`overRideFlag-${policyNo}`) == "true" ? true : false,
  };
  return body;
};

export const fetchPolicyInfo = (policyNo, access) => {
  let policyInfo = { policy: {}, policyCars: [], policyDrivers: [] };
  return new Promise((resolve, reject) => {
    Promise.all([
      fetchPolicyDriver(policyNo, access),
      fetchCarList(policyNo, access),
      fetchPolicyData(policyNo, access),
    ])
      .then((data) => {
        policyInfo.policyDrivers = data[0];
        policyInfo.policyCars = data[1];
        policyInfo.policy = data[2];
        resolve(policyInfo);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const fetchPolicyData = (policyNo, access) => {
  return new Promise((resolve, reject) => {
    getPolicyInsuredInfo(policyNo, access).then((responseData) => {
      const { response, statusCode } = responseData.data;
      if (statusCode === 200) {
        response.policyInfo.isPaperless = response.policyInfo.paperless;
        resolve(response);
      } else {
        reject(responseData.data.message);
      }
    });
  });
};

const fetchPolicyDriver = (policyNo, access) => {
  return new Promise((resolve, reject) => {
    let driverDto = {
      pagination: { currentPage: 0, pageSize: 100 },
      search: [{ criteriaName: "policyNo", value: policyNo }],
      sort: { columnName: "policyNo", orderBy: "ASC" },
    };
    getDriverListService(driverDto, access)
      .then((driverData) => {
        if (driverData) {
          let driverCounter = 0;
          let unaccaptableDrivers = JSON.parse(
            localStorage.getItem(`${policyNo}-unacceptableDrivers`),
          );

          if (
            driverData &&
            driverData.data &&
            driverData.data.response &&
            driverData.data.response.content &&
            driverData.data.response.content.length
          ) {
            driverData.data.response.content.map((driver) => {
              let policyViolations = {
                pagination: {
                  currentPage: 0,
                  pageSize: 100,
                },
                search: [
                  {
                    criteriaName: "policyNo",
                    value: policyNo,
                  },
                  {
                    criteriaName: "driverIndex",
                    value: driver.driverIndex,
                  },
                ],
                sort: {
                  columnName: "policyNo",
                  orderBy: "ASC",
                },
              };
              if (unaccaptableDrivers) {
                unaccaptableDrivers.forEach((unAdriver) => {
                  if (unAdriver.licenseNo === driver.licenseNo) {
                    driver.isDriverUnacceptableRisk =
                      unAdriver.isDriverUnacceptableRisk;
                  }
                });
              }
              getViolationList(policyViolations, access)
                .then((response) => {
                  if (
                    response.data.response &&
                    response.data.response.content
                  ) {
                    driverCounter = driverCounter + 1;

                    driver.policyDriverViolations =
                      response.data.response.content &&
                      response.data.response.content.length > 0
                        ? response.data.response.content
                        : [];
                    driver.dob = driver.dob ? driver.dob : null;
                    driver.creditScore = 0;
                    driver.dateLicensed = driver.dateLicensed
                      ? driver.dateLicensed
                      : null;
                    driver.inceptionDate = driver.inceptionDate
                      ? driver.inceptionDate
                      : null;
                    driver.seniorDefDrvDate = driver.seniorDefDrvDate
                      ? driver.seniorDefDrvDate
                      : null;

                    if (
                      driverCounter === driverData.data.response.content.length
                    ) {
                      resolve(driverData.data.response.content);
                    }
                  } else {
                    reject(response.data.message);
                  }
                })
                .catch((error) => {
                  reject(error);
                });
              return driver;
            });
          } else {
            resolve([]);
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const fetchCarList = (policyNo, access) => {
  return new Promise((resolve, reject) => {
    let carDto = {
      pagination: { currentPage: 0, pageSize: 100 },
      search: [{ criteriaName: "policyNo", value: policyNo }],
      sort: { columnName: "policyNo", orderBy: "ASC" },
    };

    getCarListService(carDto, access)
      .then((carData) => {
        if (carData) {
          let carList = [];
          let counter = 0;
          if (carData.data.response.content.length) {
            carData.data.response.content.map((car) => {
              getVehicleDetails(policyNo, car.vin, access).then(
                (result) => {
                  if (result && result.data.statusCode === 200) {
                    counter = counter + 1;
                    let carData = result.data.response;
                    // carData.businessUse = false;
                    carData.dob = carData.dob ? carData.dob : null;
                    carData.inceptionDate = carData.inceptionDate
                      ? carData.inceptionDate
                      : null;
                    carData.effDate = carData.effDate ? carData.effDate : null;
                    carData.isVinValid = true;
                    let temppolicyCarLienHolders =
                      carData.policyCarLienHolders &&
                      carData.policyCarLienHolders.length === 0
                        ? [
                            {
                              lienHolderIndex: 1,
                              name: " ",
                              address: " ",
                              city: " ",
                              state: " ",
                              zip: " ",
                              phone: "",
                              isAddInterest: false,
                              isNonInstitutional: false,
                              dateCreated: null,
                            },
                            {
                              lienHolderIndex: 2,
                              name: " ",
                              address: " ",
                              city: " ",
                              state: " ",
                              zip: " ",
                              phone: "",
                              isAddInterest: false,
                              isNonInstitutional: false,
                              dateCreated: null,
                            },
                          ]
                        : carData.policyCarLienHolders &&
                          carData.policyCarLienHolders.length === 1
                        ? carData.policyCarLienHolders.push({
                            lienHolderIndex: 2,
                            name: " ",
                            address: " ",
                            city: " ",
                            state: " ",
                            zip: " ",
                            phone: "",
                            isAddInterest: false,
                            isNonInstitutional: false,
                            dateCreated: null,
                          })
                        : carData.policyCarLienHolders &&
                          carData.policyCarLienHolders.length === 2
                        ? carData.policyCarLienHolders
                        : carData.policyCarLienHolders.splice(0, 2);
                    carData.policyCarLienHolders =
                      temppolicyCarLienHolders &&
                      temppolicyCarLienHolders.length === 2
                        ? temppolicyCarLienHolders
                        : carData.policyCarLienHolders;
                    car = carData;

                    carList.push(carData);
                  } else {
                    resolve(carData.data.response.content);
                  }
                  if (counter === carData.data.response.content.length) {
                    resolve(carList);
                  }
                },
                (error) => {},
              );
              return car;
            });
          }
        }
      })
      .catch((error) => {});
  });
};

export const setPolicyLocalStorage = (data, policyNo) => {
  localStorage.setItem(`Policy-Details-${policyNo}`, JSON.stringify(data));
  localStorage.setItem(`${policyNo}`, JSON.stringify(data.policyDrivers));
  localStorage.setItem(`${policyNo}-Cars`, JSON.stringify(data.policyCars));
};

export const getPrinciplDropDown = (policyNo) => {
  let policy = JSON.parse(localStorage.getItem(`Policy-Info-${policyNo}`));
  let driverList = policy.policyDrivers;
  let dropDownList = [];
  if (driverList) {
    driverList.forEach((driver) => {
      dropDownList.push({
        name: driver.firstName + " " + driver.lastName,
        driverIndex: driver.driverIndex,
      });
    });
  }
  return dropDownList;
};

export const isDriverPresent = (licenseNo, driverList) => {
  let isPresent = true;
  if (licenseNo !== "") {
    if (driverList) {
      driverList.forEach((driver) => {
        if (driver.licenseNo === licenseNo) {
          isPresent = false;
        }
      });
    }
  }
  return isPresent;
};

export const isDriverPresentEdit = (licenseNo, driverIndex, driverList) => {
  let isPresent = true;
  if (licenseNo !== "") {
    if (driverList) {
      driverList.forEach((driver) => {
        if (driver.licenseNo === licenseNo) {
          if (driver.driverIndex === driverIndex) {
          } else {
            isPresent = false;
          }
        }
      });
    }
  }
  return isPresent;
};
export const isCarPresent = (vin, carList) => {
  let isPresent = true;
  if (carList) {
    carList.forEach((driver) => {
      if (driver.vin === vin) {
        isPresent = false;
      }
    });
  }
  return isPresent;
};

export const getPolicyStatus1 = (policyNo, policyStatus) => {
  let isDisabled = false;
  // if(policyStatus.includes('Non-Pay')){
  //   isDisabled = true;
  // }
  if (
    policyStatus === "EXPIRED" ||
    // policyStatus === "CANCEL" ||
    policyStatus === "CANCEL (FUTURE NON-RENEWAL)" ||
    // policyStatus === "NOTICE -NON PAY" ||
    policyStatus === "NON-RENEW"
  ) {
    isDisabled = true;
  }
  return isDisabled;
};
export const getPolicyStatusForPop = (policyStatus) => {
  let isDisabled = false;
  if (policyStatus.includes("NOTICED")) {
    isDisabled = true;
  }
  if (policyStatus === "CANCEL") {
    isDisabled = true;
  }
  return isDisabled;
};
export const getPolicyStatus = (policyNo, policyStatus) => {
  let isDisabled = false;
  if (policyStatus)
    if (policyStatus.includes("NOTICED")) {
      if (
        policyStatus === "NOTICED - Underwriting Request" ||
        policyStatus === "NOTICED - UNDERWRITING REQUEST"
      ) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }
      // isDisabled = true;
    } else if (
      policyStatus === "EXPIRED" ||
      policyStatus === "CANCEL" ||
      policyStatus === "CANCEL (FUTURE NON-RENEWAL)"
    ) {
      isDisabled = true;
    }
  return isDisabled;
};

export const getCreditScore = (policyNo) => {
  let policy = JSON.parse(localStorage.getItem(`policy${policyNo}`));
  if (policy) {
    return parseInt(policy.policyInfo.creditScore);
  }
};

export const setCreditScore = (policyNo, newCreditScore) => {
  let policy = JSON.parse(localStorage.getItem(`policy${policyNo}`));
  if (policy) {
    policy.policyInfo.creditScore = newCreditScore;
    localStorage.setItem(`policy${policyNo}`, JSON.stringify(policy));
    return parseInt(newCreditScore);
  }
};

export const isPrincOpr = (policyNo, driverIndex) => {
  let policy = JSON.parse(localStorage.getItem(`Policy-Info-${policyNo}`));
  let carList = policy.policyCars;
  let isPresent = false;
  carList.forEach((row) => {
    if (row.princOpr === driverIndex) {
      isPresent = true;
    }
  });
  return isPresent;
};

export const getUserName = () => {
  let firstName = localStorage.getItem("FIRSTNAME");
  let lastName = localStorage.getItem("LASTNAME");
  if (firstName && lastName) {
    return firstName + " " + lastName;
  } else {
    return "";
  }
};

export const flushLocalStorage = (policyNo) => {
  localStorage.removeItem(`${policyNo}-Cars`);
  localStorage.removeItem(`Policy-Details-${policyNo}`);
  localStorage.removeItem(`${policyNo}`);
  // localStorage.removeItem(`amendDate-${policyNo}`);
  localStorage.removeItem(`footerSummary-${policyNo}`);
  // localStorage.removeItem(`isRecalculate-${policyNo}`);
  localStorage.removeItem(`agentEmailAddress-${policyNo}`);
  localStorage.removeItem(`confirmation-${policyNo}`);
  // localStorage.removeItem(`endorse-${policyNo}`);
  // window.location.href = '/#/app/policy/policy-CSR';
};

export const getUnacceptableDriver = (policyNo, driverIndex) => {
  let unAcceptableFlag = false;
  let driverData = JSON.parse(localStorage.getItem(`Policy-Info-${policyNo}`));
  driverData.policyDrivers.map((driver) => {
    if (driver.driverIndex === driverIndex) {
      unAcceptableFlag = driver.isDriverUnacceptableRisk;
    }
    return driver;
  });
  return unAcceptableFlag;
};

export const getLoggedUser = () => {
  let fname = localStorage.getItem("FIRSTNAME");
  let lname = localStorage.getItem("LASTNAME");
  return fname + "." + lname;
};

export const displayDigits = (displayValue) => {
  let flag = false;
  if (displayValue.includes(".")) {
    let value = displayValue.split(".");
    if (value[1].length > 2) {
      flag = true;
    } else {
      flag = false;
    }
  }
  return flag;
};

export const getSumOfPoints = (arrayData) => {
  let count = 0;
  arrayData.forEach((element) => {
    if (element.chargeable == true) {
      count += element.violationPoints;
    }
  });
  return count;
};

export const getModalTop = () => {
  window.scrollTo(0, 0);
};

export const getBodyScroll = () => {
  document.body.style.overflow = "auto";
};

export const getTitle = (policy, props) => {
  if (props.match.path === "/app/policy-view/:policyNo") {
    document.title = policy;
  } else {
    document.title = "Titan";
  }
};

export const getBodyHidden = () => {
  document.body.style.overflow = "hidden";
};

export const getPolicyStatusInfo = (policyNo) => {
  let policy = JSON.parse(localStorage.getItem(`policy${policyNo}`));
  return policy ? policy.policyInfo.policyStatus : null;
};

export const getDropDownOptions = (data, keepIndex = false) => {
  let dropDownValues = [];
  data.map((option, index) => {
    dropDownValues.push({
      value: keepIndex ? option.value : option.name,
      name: option.name,
    });
    return option;
  });
  return dropDownValues;
};

export const setTitle = (claimNo, props) => {
  document.title = claimNo;
};

export const getTotal = (data) => {
  let sum = 0;

  data.forEach((element) => {
    sum += element.totalAmt;
  });
  return sum;
};
